import { inject, Injectable } from '@angular/core';
import { ViewSubjects } from '@sharedlib/common/permissions/types/Permissions';
import { take } from 'rxjs';
import { AccountService } from '../services/account.service';
import { Account } from '../types/account';
import { HasPermissionGuard } from './has-permission.guard';

@Injectable({
  providedIn: 'root',
})
export class MailAppGuard extends HasPermissionGuard {
  private readonly accountService = inject(AccountService);
  constructor() {
    super('read', ViewSubjects.mailView);
  }

  protected override onForbidden(): void {
    this.accountService
      .getAccount()
      .pipe(take(1))
      .subscribe((account) => {
        if (Account.hasActiveSubscriptionStatus(account.subscriptionStatus)) {
          this.router.navigate(['/settings']);
        } else {
          this.router.navigate(['/settings/general/billing']);
        }
      });
  }
}
